"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteButton = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
const DeleteButton = props => {
  const {
    label,
    onClick,
    dataTestId
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    ml: -1,
    mb: 6,
    display: "flex",
    alignItems: "center",
    component: "label",
    sx: {
      cursor: 'pointer'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
      variant: "text",
      size: "small",
      color: "primary",
      "data-testid": getTestId(`${dataTestId}button`),
      onClick: onClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Trashcan, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      ml: 1,
      variant: "body1",
      children: label
    })]
  });
};
exports.DeleteButton = DeleteButton;
